/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 */
import { api } from '../../../config/api';

import type { CreateDraftApiArg, CreateDraftResponse } from '../types';

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    createDraft: build.mutation<CreateDraftResponse, CreateDraftApiArg>({
      query: (queryArg) => ({
        body: queryArg.body,
        method: 'POST',
        url: `/v1/quick-draft/${queryArg.date}`,
      }),
    }),
  }),
  overrideExisting: true,
});

export { injectedRtkApi as createDraftApi };
export const { useCreateDraftMutation } = injectedRtkApi;
